import { Injectable } from '@angular/core';
import { ValidatorService } from 'src/app/core/validator/validator.service';
import { ProductGroup } from 'src/app/order/models/product-group.model';

@Injectable({
  providedIn: 'root'
})
export class ProductGroupValidatorService extends ValidatorService {
  isValid(data: ProductGroup) {
    this.errors = [];

    if (!this.isSupplied(data.name)) {
      this.errors.push('name');
    }

    if (!this.isSupplied(data.code)) {
      this.errors.push('code');
    }

    return this.errors.length === 0;
  }
}
